import React from "react";
import Proptypes from "prop-types";

import { CloudinaryImage } from "@website-builder/ui/shared/elements";
import { InvestorsWrapper } from "./style";

const Investors = (props) => {
	const { header, text, investors } = props;

	return (
		<InvestorsWrapper>
			<h2 className="header">{header}</h2>
			<div className="text">{text}</div>
			<div className="investerWrapper">
				{investors.map((investor, index) => (
					<div key={index} className="container">
						<div className="image">
							<CloudinaryImage lazyload url={investor.image} />
						</div>
						<div className="description">
							<div className="name">{investor.heading}</div>
							<div className="designation">{investor.description}</div>
						</div>
					</div>
				))}
			</div>
		</InvestorsWrapper>
	);
};

Investors.propTypes = {
	header: Proptypes.string,
	text: Proptypes.string,
	investors: Proptypes.array,
};

Investors.defaultProps = {
	header: "",
	text: "",
	investors: [],
};

export default Investors;
